import { Component, inject, Input } from '@angular/core'
import { DynamicCMInputArray } from '@core/models/calculation-module.model'
import { CalculationModuleService } from '@core/services/calculation-module.service'
import { CmInputComponent } from '../cm-input/cm-input.component'

@Component({
  selector: 'app-dynamic-cm-inputs-array',
  templateUrl: './dynamic-cm-inputs-array.component.html',
  styleUrl: './dynamic-cm-inputs-array.component.scss',
  imports: [
    // Components
    CmInputComponent,
  ],
})
export class DynamicCmInputArrayComponent {
  @Input({ required: true }) dynamicCMInputArray!: DynamicCMInputArray // Received from SSOT
  private readonly _calculationModuleService = inject(CalculationModuleService)

  onInputOccurrenceChange(event: Event) {
    // Updates default_inputs_amount in SSOT
    const input = event.target as HTMLInputElement
    const value = parseInt(input.value, 10)
    this._calculationModuleService.updateDynamicCMInputArrayOccurrence(
      this.dynamicCMInputArray.input_parameter_name,
      value,
    )
  }

  // handle ArrayOfRegularInput input value changes
  onChildInputValueChange(event: { value: any; index: number }) {
    // @Output from ArrayOfRegularInput cm-input component, will update this DynamicCMInputArray with new values in ArrayOfRegularInput
    const { value, index } = event
    this._calculationModuleService.updateDynamicCMInputArrayArrayOfRegularInput(
      this.dynamicCMInputArray.input_parameter_name,
      value,
      index,
    )
  }
}
